// Growem — offline nutrition fallback. Used when the AI proxy is unavailable so meal logging
// never blocks. Heuristic: sum every matched food row's macros ×2 (assume ~2 portions).

import type { FoodRule, MealEstimate } from '../types'

export const FOODS: FoodRule[] = [
  { re: /huevo/i, kcal: 78, prot: 6.3, carbs: 0.6, fat: 5.3, portion: 'unidad' },
  { re: /pollo|pechuga/i, kcal: 165, prot: 31, carbs: 0, fat: 3.6, portion: '100 g' },
  { re: /carne|res/i, kcal: 250, prot: 26, carbs: 0, fat: 15, portion: '100 g' },
  { re: /atún/i, kcal: 116, prot: 26, carbs: 0, fat: 1, portion: 'lata' },
  { re: /arroz/i, kcal: 130, prot: 2.7, carbs: 28, fat: 0.3, portion: '100 g' },
  { re: /papa|pur[eé]/i, kcal: 87, prot: 2, carbs: 20, fat: 0.1, portion: '100 g' },
  { re: /arepa/i, kcal: 200, prot: 4, carbs: 40, fat: 3, portion: 'unidad' },
  { re: /avena/i, kcal: 145, prot: 5, carbs: 25, fat: 3, portion: '40 g' },
  { re: /batido|scoop|prote[íi]na en polvo/i, kcal: 130, prot: 26, carbs: 3, fat: 1.5, portion: 'scoop' },
  { re: /queso/i, kcal: 100, prot: 7, carbs: 1, fat: 8, portion: '40 g' },
  { re: /banana|banano/i, kcal: 105, prot: 1.3, carbs: 27, fat: 0.4, portion: 'unidad' },
  { re: /tilapia|salm[oó]n|pescado/i, kcal: 200, prot: 25, carbs: 0, fat: 10, portion: '100 g' },
]

export function estimateLocal(txt: string): MealEstimate {
  let kcal = 0, prot = 0, carbs = 0, fat = 0, hit = false
  for (const f of FOODS) {
    if (f.re.test(txt)) {
      hit = true
      kcal += f.kcal * 2; prot += f.prot * 2; carbs += f.carbs * 2; fat += f.fat * 2
    }
  }
  if (!hit) { kcal = 600; prot = 35; carbs = 60; fat = 20 }
  const nombre = txt.trim().slice(0, 40) || 'Comida'
  return {
    nombre,
    kcal: Math.round(kcal), prot: Math.round(prot), carbs: Math.round(carbs), fat: Math.round(fat),
    note: hit ? 'Estimación offline. Ajusta si no cuadra.' : 'Sin conexión y sin match — estimación base, ajústala.',
    source: 'ai_local',
  }
}
